import type { ModelConfig } from '@swf/core/store';

import selectors from './selectors';

const effects = {};
const reducers = {};

export const defaultState = {};

interface SportsModel extends ModelConfig<typeof defaultState> {
  reducers: typeof reducers;
  effects: typeof effects;
  selectors: typeof selectors;
}

const sports: SportsModel = {
  state: {},
  reducers,
  effects,
  selectors
};

export default sports;
